export default __webpack_public_path__ + "static/media/v-kool.e89237a5.webp";